import React from "react";

export default function LoadingWorkout() {
  return (
    <div className="container max-w-md mx-auto p-4 flex justify-center items-center min-h-[60vh]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p>Loading workout...</p>
      </div>
    </div>
  );
}
